import styled, { css } from 'styled-components'
import { Button } from '@dataplace.ai/ui-components/atoms'

export const Section = styled.div(({
  theme: {
    palette,
    corners,
  },
}) => css`
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: ${palette.light.white};
    border: 1px solid ${palette.light.darkest};
    border-radius: ${corners.default.borderRadius};
    color: ${palette.black};
    margin-bottom: 30px;

    @media print {
      border: none;
    }
`)

export const SimilarAdressWrapper = styled.ul(({ theme: { palette } }) => css`
  width: 100%;
  list-style-type: none;
  
  >li:nth-child(2n) {
    background-color: ${palette.light.main};
  }
`)

export const SectionTitle = styled.h4(({ theme: { typography } }) => css`
  font-size: ${typography.main.pt_15_medium_upper.fontSize};
  font-weight: ${typography.main.pt_15_medium_upper.fontWeight};
  line-height: ${typography.main.pt_15_medium_upper.lineHeight};
  letter-spacing: ${typography.main.pt_15_medium_upper.letterSpacing};
  text-transform: ${typography.main.pt_15_medium_upper.textTransform};
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`)

export const RegularSpan = styled.span(({ theme: { typography } }) => css`
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  font-size: ${typography.small.pt_13_regular.fontSize};
  font-weight: ${typography.small.pt_13_regular.fontWeight};
  line-height: ${typography.small.pt_13_regular.lineHeight};
  text-align: right;
`)

export const AddressSpan = styled.span(({ theme: { typography } }) => css`
  font-size: ${typography.small.pt_13_semibold.fontSize};
  font-weight: ${typography.small.pt_13_semibold.fontWeight};
  line-height: ${typography.small.pt_13_semibold.lineHeight};
`)

export const Estimation = styled.div(({ theme: { palette } }) => css`
  padding-bottom: 30px;
  margin: 30px 0;
  border-bottom: 1px solid ${palette.light.darkest};
`)

export const EstimationParagraph = styled.p(({
  theme: {
    palette,
    typography,
  },
}) => css`
    font-size: ${typography.main.pt_15_semibold.fontSize};
    line-height: ${typography.main.pt_15_semibold.lineHeight};
    font-weight: ${typography.main.pt_15_semibold.fontWeight};
    letter-spacing: ${typography.main.pt_15_semibold.letterSpacing};
    color: ${palette.black};
    > strong {
        font-size: 28px;
        line-height: 40px;
        margin-left: 0.5rem;
    }
  `)

export const EstimationLabel = styled.span(({
  theme: {
    palette,
    typography,
  },
}) => css`
    color: ${palette.black};
    font-size: ${typography.small.pt_13_regular.fontSize};
    font-weight: ${typography.small.pt_13_regular.fontWeight};
    line-height: ${typography.small.pt_13_regular.lineHeight};
  `)

export const ChartTitle = styled.h5(({
  theme: {
    palette,
    typography,
  },
}) => css`
    font-weight: 500;
    font-size: ${typography.main.pt_15_semibold_upper.fontSize};
    line-height: ${typography.main.pt_15_semibold_upper.lineHeight};
    letter-spacing: ${typography.main.pt_15_semibold_upper.letterSpacing};
    text-transform: ${typography.main.pt_15_semibold_upper.textTransform};
    color: ${palette.black};
  `)

export const SectionMainText = styled.span(({ theme: { typography } }) => css`
  font-size: ${typography.small.pt_13_regular.fontSize};
  font-weight: ${typography.small.pt_13_regular.fontWeight};
  line-height: ${typography.small.pt_13_regular.lineHeight};
  margin-bottom: 10px;
`)

export const TagButtonWrapper = styled.div(() => css`
  width: 100%;
  display: flex;
  justify-content: flex-end; 
  margin-top: 100px;
`)

export const StyledButton = styled(Button)`
  padding: 9px;
`

export const SeeMoreWrapper = styled.div(({ theme: { palette } }) => css`
  background-color: ${palette.light.darker};
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: -20px;
  margin-bottom: -20px;
  margin-top: 20px;
  padding: 26px 20px;
  border-top: 1px solid ${palette.light.darkest};
`)

export const StyledSpan = styled.span(() => css`
  max-width: 60%;
  margin-right: 1rem;
`)

interface TitleProps {
  $borderTop?: boolean
}

export const SubTitle = styled.h5<TitleProps>(({
  theme: {
    palette,
    typography,
  },
  $borderTop,
}) => css`
  font-weight: 600;
  font-size: ${typography.tiny.pt_12_semibold.fontSize};
  line-height: ${typography.tiny.pt_12_semibold.lineHeight};
  letter-spacing: ${typography.tiny.pt_12_semibold.letterSpacing};
  text-transform: ${typography.tiny.pt_12_medium_upper.textTransform};
  color: ${palette.black};
  margin-bottom: 10px;
  ${$borderTop && css`
      border-top: 1px solid ${palette.light.darker};
      padding-top: 1.5rem;
      margin-top: 1.5rem;
  `}
  `)

export const Wrapper = styled.div(({ theme: { palette } }) => css`
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem;
  background-color: ${palette.light.white};
`)
